<template>
    <AdminText v-bind="$attrs" :id="props.id" ref="input" v-model="modelValue" :size="props.size" :dusk="dusk" />
</template>

<script setup lang="ts">
import { toRefs, watch } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: [String, Number],
});

const props = withDefaults(defineProps<FieldComponent & { forbidden?: string[] }>(), {
    source: '',
    slugifyFromSource: true,
    forbidden: () => [],
});

const { source } = toRefs(props);

let slugifyTimeout = null;

const deferredSlugify = (value: string) => {
    clearTimeout(slugifyTimeout);
    slugifyTimeout = setTimeout(async () => {
        modelValue.value = await slugify(value);
    }, 500);
};

const slugify = async (value: string) => {
    const separator = (props.params as any)?.separator ?? '-';
    const response = await axios.get(route('fields.string.slugify'), {
        params: {
            string: value,
            forbidden: props.forbidden,
            separator,
        },
    });
    return response.data.slug;
};

watch(source, async (value) => {
    if (!props.slugifyFromSource) return;

    deferredSlugify(`${value}`);
});
</script>
